var h = Object.defineProperty, m = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, f = Object.prototype.propertyIsEnumerable;
var l = (t, e, s) => e in t ? h(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s, a = (t, e) => {
  for (var s in e || (e = {}))
    d.call(e, s) && l(t, s, e[s]);
  if (r)
    for (var s of r(e))
      f.call(e, s) && l(t, s, e[s]);
  return t;
}, o = (t, e) => m(t, c(e));
import { h as p } from "vue";
import { _ as u } from "../_plugin-vue_export-helper-dad06003.js";
import { w as S } from "../util-b2b0dc25.js";
const I = function(t) {
  return isNaN(t);
}, B = {
  name: "rStepDialog",
  props: {
    /**
     * 开始
     */
    start: {
      type: Boolean,
      default: !1
    },
    /**
     * 上一步按钮loading
     */
    prevBtnLoading: {
      type: Boolean,
      default: !1
    },
    /**
     * 下一步按钮loading
     */
    nextBtnLoading: {
      type: Boolean,
      default: !1
    },
    /**
     * 上一步按钮禁用
     */
    prevBtnDisabled: {
      type: Boolean,
      default: !1
    },
    /**
     * 下一步按钮禁用
     */
    nextBtnDisabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      currentStep: 0,
      willStep: 1 / 0
    };
  },
  watch: {
    start() {
      this.currentStep = 0;
    }
  },
  computed: {
    stepItemsVnode() {
      return this.getAllStepItemFromArrayDeep(this.$slots.default());
    },
    stepItemsData() {
      return this.stepItemsVnode.map((t, e) => ({
        name: t.props.name,
        index: e
      }));
    },
    finnalStep() {
      return this.stepItemsVnode.length - 1;
    }
  },
  methods: {
    /**
     * 到指定步。参数：[step]，可以是从0开始的索引，也可以使用step-dialog-item的name
     */
    toStep(t) {
      if (this.currentStep === 1 / 0 || this.willStep != 1 / 0)
        return;
      let e = null;
      if (I(t)) {
        const s = this.findItemByName(t);
        s && (e = s.index);
      } else
        e = t;
      e !== this.currentStep && (this.currentStep = 1 / 0, this.willStep = e);
    },
    findItemByIndex(t) {
      return this.stepItemsData[t] || void 0;
    },
    findItemByName(t) {
      for (let e = 0; e < this.stepItemsData.length; e++) {
        const s = this.stepItemsData[e];
        if (s.name === t)
          return s;
      }
    },
    beforeClose() {
      this.$emit("beforeClose", this.findItemByIndex(this.currentStep));
    },
    prevBtnClick() {
      const t = this.findItemByIndex(this.currentStep);
      this.currentStep === 0 ? this.$emit("onCancel", t) : this.$emit("onPrev", t, () => {
        this.toStep(this.currentStep - 1);
      }), this.$emit("willChange", t);
    },
    nextBtnClick() {
      const t = this.findItemByIndex(this.currentStep);
      this.currentStep === this.finnalStep ? this.$emit("onComfirm", t) : this.$emit("onNext", t, () => {
        this.toStep(this.currentStep + 1);
      }), this.$emit("willChange", t);
    },
    stepDidChange(t) {
      const e = this.findItemByIndex(t);
      this.$emit("didChange", e);
    },
    closed() {
      this.currentStep = this.willStep, this.willStep = 1 / 0, this.stepDidChange(this.currentStep);
    },
    getAllStepItemFromArrayDeep(t) {
      let e = [];
      return t.forEach((s) => {
        var n, i;
        (i = (n = s.type) == null ? void 0 : n.name) != null && i.endsWith("rStepDialogItem") ? e.push(s) : s.children && Array.isArray(s.children) && e.push(...this.getAllStepItemFromArrayDeep(s.children));
      }), e;
    },
    renderItems() {
      return this.stepItemsVnode.map((t, e) => {
        const s = t.props;
        return p(
          t.type,
          o(a({
            "model-value": this.start && e === this.currentStep,
            class: s.class,
            isLast: this.finnalStep === e,
            isFirst: e === 0,
            prevBtnLoading: e === this.currentStep ? this.prevBtnLoading : !1,
            nextBtnLoading: e === this.currentStep ? this.nextBtnLoading : !1,
            prevBtnDisabled: e === this.currentStep ? this.prevBtnDisabled : !1,
            nextBtnDisabled: e === this.currentStep ? this.nextBtnDisabled : !1
          }, s), {
            onPrevBtnClick: this.prevBtnClick,
            onNextBtnClick: this.nextBtnClick,
            onBeforeClose: this.beforeClose,
            onClosed: this.closed
          }),
          t.children
        );
      });
    }
  },
  render() {
    return p(
      "div",
      {
        class: "r-step-dialog"
      },
      this.renderItems()
    );
  },
  emits: {
    /**
     * 点击右上角关闭回调，step为当前步
     */
    beforeClose: (t) => t,
    /**
     * 点击首页取消按钮
     */
    onCancel: null,
    /**
     * 点击上一步按钮，step为当前步，执行toPrev到上一步
     */
    onPrev: (t, e) => t,
    /**
     * 点击下一步按钮，step为当前步，执行toNext到下一步
     */
    onNext: (t, e) => t,
    /**
     * 点击最后一页确认按钮
     */
    onComfirm: null,
    /**
     * 即将改变步骤，step为当前步，onPrev和onNext时均会触发
     */
    willChange: (t) => t,
    /**
     * 步骤改变之后，step为最新步
     */
    didChange: (t) => t
  }
}, g = /* @__PURE__ */ u(B, [["__file", "/Users/dave/Documents/dev/bmui3/src/packages/step-dialog/step-dialog.vue"]]), v = S(g);
export {
  v as default
};
